export const MAX_GROUPS = 10;
export const MAX_SHEETS = 50;
export const MAX_ANIMATION_FRAMES = 15;
export const MAX_CANVAS_OBJECTS = 100;
export const MONITOR_URL = 'https://monitor.geomix-soccerboard.com:45637/';
